import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import httpClient from '@utils/HttpClient.ts'

import type { components } from '@/schema'

export function useViewSettings() {
  return useQuery({
    queryKey: ['view-settings'],
    queryFn: () => httpClient.get<components['schemas']['ViewSettingsResponse']>('/api/store-view/settings'),
    staleTime: ms('1h'),
  })
}
